import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand navbar-white py-1 bg-green" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo-small.png",
  alt: "NG Hantverk logotyp",
  class: "w-100"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"collapse navbar-collapse d-flex\" id=\"meny-top\"><ul class=\"navbar-nav ms-auto mb-2 mb-lg-0\"><li style=\"margin-right:5px;font-size:2rem;\"><a href=\"https://www.instagram.com/nghantverk/\" target=\"_blank\" class=\"accent-3--link accent-3 text-decoration-none follow-us\"> Följ <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" fill=\"currentColor\" class=\"bi bi-instagram\" viewBox=\"0 0 16 16\"><path d=\"M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z\"></path></svg> nghantverk </a></li></ul></div>", 1)
const _hoisted_7 = {
  class: "alert alert-info alert-dismissible fade show rounded-0 mb-0 text-center",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode(" Tack för alla möten på "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://knivexpo.se",
    target: "_blank"
  }, "KnivExpo"),
  /*#__PURE__*/_createTextVNode(" i Vadstena. Vi ses nästa år! ")
], -1)
const _hoisted_9 = { class: "app pb-3 container px-4 px-lg-5 py-5" }
const _hoisted_10 = {
  class: "container-fluid border-top text-gray-light",
  style: {"background-color":"#333333 !important"}
}
const _hoisted_11 = { class: "py-5 container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-7 contact-us order-2 order-md-1\"><h5 class=\"accent-3\">KONTAKTA</h5><ul class=\"nav flex-column\"><li class=\"nav-item mb-2\"><a href=\"mailto:micke@nghantverk.se\" class=\"nav-link p-0 text-gray-light\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-envelope-fill\" viewBox=\"0 0 16 16\"><path d=\"M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z\"></path></svg> MICKE@NGHANTVERK.SE </a></li><li class=\"nav-item mb-2\"><a href=\"mailto:jimmy@nghantverk.se\" class=\"nav-link p-0 text-gray-light\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-envelope-fill\" viewBox=\"0 0 16 16\"><path d=\"M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z\"></path></svg> JIMMY@NGHANTVERK.SE </a></li></ul></div>", 1)
const _hoisted_14 = { class: "col-md-5 order-1 order-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between py-4 my-4 border-top border-green" }, [
  /*#__PURE__*/_createElementVNode("p", null, "© 2023 NG Hantverk")
], -1)

import { onMounted, ref } from 'vue';
    import { categoryApi } from '@/services/category.service';
    import { useRootStore } from '@/store/root.store';
    import Newsletter from '@/components/Newsletter.vue';
    import CookieBar from '@/components/CookieBar.vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const rootStore = useRootStore();
    const showAlert = ref<boolean>(true);

    onMounted(async () => {
        rootStore.setCategories(await categoryApi.getAll());
    });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name:'Start' },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate }) => [
            _createElementVNode("a", {
              class: "navbar-brand",
              href: href,
              onClick: navigate
            }, _hoisted_5, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _hoisted_6
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createTextVNode("🤠"),
      _createElementVNode("button", {
        type: "button",
        class: "btn-close",
        "aria-label": "Stäng",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showAlert.value = false), ["prevent"]))
      })
    ], 512), [
      [_vShow, showAlert.value]
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("footer", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Newsletter)
          ])
        ]),
        _hoisted_15
      ])
    ]),
    _createVNode(CookieBar)
  ], 64))
}
}

})